import { SiteCabinetVeterinaire } from "./SiteCabinetVeterinaire";

export class CabinetVeterinaire {
    id!: number;
    nom!: string;
    sitesCabinets: SiteCabinetVeterinaire[] = new Array();
}